// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 792 ? "main" : chunkId) + "." + {"272":"25d357ca","792":"0107a531"}[chunkId] + ".css";
};